<template>
  <div class="knowledge-detail">
    <bscroll-view ref="detailBScrollView" :scroll-handler="detailScrollHandler">
      <div class="knowledge-detail-content">
        <div class="content-body">
          <div class="detail-wrap">
            <div class="detail-content">
              <h5 class="name">
                {{ langTransfer(baseData.name) }}
              </h5>
              <div class="infos">
                <div class="cover hb-resource-cover">
                  <img v-lazy="baseData.poster">
                </div>
                <p v-if="baseData.describes"
                   class="summary text3line"
                   @click="showDialog = true"
                >
                  {{ langTransfer(baseData.describes) }}
                </p>
              </div>
            </div>
          </div>
          <div class="wrap-line" :style="{transform: `translateY( ${mainContentPosY}px )`}"/>
          <div class="main-content">
            <div class="menu-mask" :style="{transform: `translateY( ${mainContentPosY}px )`}">
              <bscroll-view>
                <div class="menu-content">
                  <el-menu
                      :default-active="activedMenu"
                      unique-opened
                  >
                    <el-submenu v-for="(item,index) in catelog"
                                :key="index"
                                :index="item.unique_code"
                    >
                      <p slot="title"
                         class="custom-title text1line"
                      >
                        {{ langTransfer(item.name) }}
                      </p>
                      <el-menu-item v-for="(sub,i) in item.child"
                                    :key="i"
                                    :index="sub.unique_code"
                      >
                        <p class="custom-sub-item text1line" @click="subMenuClick(sub)">
                          <i/>
                          {{ langTransfer(sub.name) }}
                        </p>
                      </el-menu-item>
                    </el-submenu>
                  </el-menu>
                </div>
              </bscroll-view>
            </div>

            <div class="result-wrap">
              <div class="result-header" :style="{transform: `translateY( ${mainContentPosY}px )`}">
                <h5>
                  {{ langTransfer(checkedSubMenuObj ? checkedSubMenuObj.name : '') }}
                </h5>
              </div>
              <div class="result-content">
                <div v-for="(item,index) in list"
                     :key="index"
                     class="result-item"
                     @click="goDetail(item)"
                >
                  <div class="infos">
                    <h6 class="text1line">
                      {{ langTransfer(item.title) }}
                    </h6>
                    <p class="text2line">
                      {{ langTransfer(item.describes) }}
                    </p>
                    <div class="other-info">
                      {{
                        langTransfer(
                            `${item.torFOriginal} | ${item.cate_name} ${item.author_name}`
                        )
                      }}
                    </div>
                    <img v-show="webInfo.isAllowLogin == '1'"
                         class="collect-icon"
                         :src="item.follow_state == 1?
                                                 require('@/assets/img/collect-ed.png'):
                                                 require('@/assets/img/collect.png')"
                         @click.stop="collect(item)"
                    >
                  </div>

                  <div v-show="item.poster" class="cover hb-resource-cover">
                    <img v-lazy="item.poster">
                  </div>
                </div>
                <div class="action-warning-wrap">
                  <button v-show="list.length > 0 && !getAll"
                          class="common-read-more lr-img-scale"
                          @click="loadMore"
                  >
                    {{ langTransfer('加载更多') }}
                  </button>
                  <div v-show="list.length > 0 && getAll"
                       class="has-no-more"
                  >
                    {{ langTransfer('- 没有更多了 -') }}
                  </div>
                </div>
              </div>
            </div>

            <div class="subscribe-card-wrap" :style="{transform: `translateY( ${mainContentPosY}px )`}">
              <div class="subscribe-card">
                <div v-if="checkedSubMenuObj" class="infos">
                  <h4 class="text1line">
                    {{ langTransfer(checkedSubMenuObj.__parentName) }}
                  </h4>
                  <h5 class="text1line">
                    {{ langTransfer(checkedSubMenuObj.name) }}
                  </h5>
                </div>
                <div v-if="checkedSubMenuObj" class="cover hb-resource-cover">
                  <img :src="checkedSubMenuObj.poster" alt="">
                </div>
              </div>
              <div v-show="webInfo.isAllowLogin=='1' && checkedSubMenuObj"
                   class="subscribe-btn-wrap"
              >
                <div @click="addFocus">
                  <LottieSubscribeBtn :is-collection="isCollection"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer-com/>
      </div>
    </bscroll-view>
    <el-dialog width="820px"
               class="common-custom-dialog"
               :visible.sync="showDialog"
               :show-close="false"
    >
      <div class="dialog-content-wrap">
        <div class="close">
          <img src="@/assets/img/close.png" @click="showDialog = false">
        </div>
        <div class="texts-wrap">
          <h5>
            {{ langTransfer(baseData.name) }}
          </h5>
          <p class="summary">
            {{ langTransfer(baseData.describes) }}
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BscrollView from '@/components/bscrollView'
import FooterCom from '@/components/footerCom/footerCom'
import LottieSubscribeBtn from '@/components/lottieActions/subscribe'
import {getAuthorArticleList, getKonwledgeList, isCollection} from '@/api/hb'
import {authentication} from "@/api/lxc";
import store from "@/store";

export default {
  name: 'ClassMore',
  components: {
    FooterCom,
    BscrollView,
    LottieSubscribeBtn
  },
  data() {
    return {
      showDialog: false,
      baseData: {},
      list: [],
      activedMenu: '',
      checkedSubMenuObj: undefined,
      isCollection: undefined,
      getAll: false,
      mainContentPosY: 0,
      fixLayoutLimitPx: 348
    }
  },
  computed: {
    pageSetup() {
      return this.$store.state.pageSetup
    },
    webInfo() {
      return this.$store.state.webInfo
    },
    catelog() {
      const {baseData} = this
      if (baseData.child && baseData.child.length > 0) {
        return baseData.child
      }
      return []
    },
    user_unique_code() {
      return this.$store.state.user_unique_code
    }
  },
  watch: {
    webInfo(newVal) {
      if (newVal.service_code) {
        this.getKonwledgeDetail()
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    detailScrollHandler(pos) {
      if (pos.scrollTop > this.fixLayoutLimitPx) {
        this.mainContentPosY = pos.scrollTop + -this.fixLayoutLimitPx
      } else {
        this.mainContentPosY = 0
      }
    },
    loadMore() {
      if (this.getAll) {
        return
      }
      const newPage = Math.ceil(this.list.length / 10) + 1
      this.getArticleList(newPage)
    },
    subMenuClick(item) {
      this.checkedSubMenuObj = item
      this.checkedSubMenuObj.__parentName = this.findCheckedParentName()
      this.$router.replace({
        params: {
          subId: item.unique_code
        }
      })
    },
    findCheckedParentName() {
      const {checkedSubMenuObj} = this
      const result = this.catelog.find((e) => {
        return e.child.findIndex((sub) => {
          return sub.unique_code === checkedSubMenuObj.unique_code
        }) !== -1
      })
      return result ? result.name : ''
    },
    initActiveMenu() {
      const {baseData} = this
      if (this.$route.params.subId) {
        this.activedMenu = this.$route.params.subId
        const arrSub = []
        baseData.child.forEach((e) => {
          e.child.forEach((sub) => {
            arrSub.push(sub)
          })
        })
        const obj = arrSub.find((e) => {
          return e.unique_code === this.$route.params.subId
        })
        this.checkedSubMenuObj = obj
        this.checkedSubMenuObj.__parentName = this.findCheckedParentName()
        this.isCollection = undefined
        this.getAll = false
        this.getIsCollection()
        this.getArticleList()
        return
      }
      this.activedMenu = baseData.child[0].child[0].unique_code;
      [this.checkedSubMenuObj] = baseData.child[0].child
      this.checkedSubMenuObj.__parentName = this.findCheckedParentName()
      this.isCollection = undefined
      this.getAll = false
      this.getIsCollection()
      this.getArticleList()
    },
    async getKonwledgeDetail() {
      try {
        const data = await getKonwledgeList({
          service_code: this.webInfo.service_code,
          tag: 6,
          parent_code: this.$route.params.id
        })
        this.baseData = data
        if (data.child && data.child.length > 0) {
          this.initActiveMenu()
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getIsCollection() {
      try {
        const data = await isCollection({
          service_code: this.webInfo.service_code,
          type: 3,
          res_code: this.checkedSubMenuObj.unique_code,
          user_unique_code: this.user_unique_code
        })
        const {follow_state} = data
        if (data) {
          this.isCollection = Number(follow_state) === 1
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getArticleList(page = 1) {
      try {
        if (!this.checkedSubMenuObj) {
          return
        }
        const {unique_code} = this.checkedSubMenuObj
        const data = await getAuthorArticleList({
          author_unique_code: unique_code,
          page,
          pageSize: 10,
          user_unique_code: this.user_unique_code
        })
        if (data.length < 10) {
          this.getAll = true
        }
        if (page !== 1) {
          this.list = this.list.concat(data)
          return
        }
        this.list = data
      } catch (err) {
        if (err.code === '-1') {
          this.getAll = true
        }
        console.log(err)
      }
    },
    goDetail(item) {
      authentication().then(() => {
        const {params} = this.$route
        const {href} = this.$router.resolve({
          name: 'knowledgeLibArticle',
          params: {
            id: item.unique_code,
            secParentId: params.id
          }
        })
        window.open(href, '_blank')
      }).catch(() => {
        store.commit('setShowLoginRegister', true)
        store.commit('setMustLogin', true)
      })
    },
    addFocus() {
      const formData = {
        type: 3,
        res_code: this.checkedSubMenuObj.unique_code
      }
      const callback = (bool) => {
        if (bool) {
          this.isCollection = false
        } else {
          this.isCollection = true
        }
      }
      this.$utils.userCollect(formData, callback)
    },
    collect(item) {
      const formData = {
        type: 1,
        res_code: item.unique_code
      }
      const callback = (bool) => {
        if (bool) {
          item.follow_state = 2
        } else {
          item.follow_state = 1
        }
        this.$forceUpdate()
      }
      this.$utils.userCollect(formData, callback)
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.isCollection = undefined
    this.getAll = false
    this.$refs.detailBScrollView.bscrollObj.scrollTo(0, -this.fixLayoutLimitPx)
    this.getIsCollection()
    this.getArticleList()
    next()
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      const {service_code} = vm.webInfo
      if (service_code) {
        vm.getKonwledgeDetail()
      }
    })
  }
}
</script>

<style scoped lang="less">
.knowledge-detail {
  overflow: auto!important;
  width: 100%;
  //height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.knowledge-detail-content {
  width: 100%;
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.content-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}

.detail-wrap {
  width: 100%;
  height: 330px;
  background-image: url("~@/assets/img/knowledge-detail-bg.png");
  background-position: center center;
  background-repeat: repeat;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .detail-content {
    width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .name {
    height: 60px;
    margin: 80px 0 30px;
    font-size: 60px;
    font-family: AlibabaPuHuiTiB;
    color: #FFFFFF;
    line-height: 60px;
    user-select: none;
  }

  .infos {
    width: 100%;
    height: 178px;
    box-sizing: border-box;
    padding: 30px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 3;
  }

  .cover {
    width: 270px;
    height: 118px;
    border-radius: 8px;
  }

  .summary {
    margin-left: 30px;
    flex: 1;
    height: 72px;
    font-size: 15px;
    font-family: AlibabaPuHuiTiR;
    color: #909399;
    line-height: 24px;
    cursor: pointer;
    user-select: none;
  }
}

.wrap-line {
  width: 100%;
  height: 38px;
  background: #fff;
  position: relative;
  z-index: 2;
}

.main-content {
  width: 1200px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  .menu-mask {
    width: 300px;
    height: calc(100vh - 60px - 20px - 20px - 50px);
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow: auto;
    position: relative;
    z-index: 2;
  }

  .menu-content {
    width: 100%;
    margin: 20px 0;
  }
}

.result-wrap {
  width: 539px;
}

.result-header {
  width: 100%;
  height: 36px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  user-select: none;
  position: relative;
  z-index: 2;
  background: #fff;

  h5 {
    width: fit-content;
    height: 36px;
    box-sizing: border-box;
    padding: 10px 20px;
    font-size: 16px;
    font-family: AlibabaPuHuiTiB;
    color: #303133;
    line-height: 16px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  }

  &::after {
    content: "";
    display: block;
    flex: 1;
    height: 4px;
    background: #F0F2F5;
  }
}

.result-content {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 0 19px;
  margin: 10px 0 100px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.result-item {
  width: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;

  &:first-child {
    margin-top: 0px;
  }

  .infos {
    flex: 1;
    height: 120px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;

    h6 {
      transition: .3s;
      max-width: 100%;
      font-size: 18px;
      font-family: AlibabaPuHuiTiM;
      font-weight: 500;
      color: #606266;
      line-height: 24px;
    }

    p {
      transition: .3s;
      height: 48px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      line-height: 24px;
      margin: 4px 0 24px;
    }

    .other-info {
      transition: .3s;
      font-size: 13px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      line-height: 20px;
    }

    .collect-icon {
      opacity: 0;
      position: absolute;
      right: 0;
      bottom: -2px;
      width: 24px;
      height: 24px;
      transition: .3s;
    }
  }

  &:hover {

    .infos {

      h6 {
        color: #303133;
      }

      p {
        color: #606266;
      }

      .other-info {
        color: #606266;
      }

      .collect-icon {
        opacity: 1;
      }
    }
  }

  .cover {
    width: 120px;
    height: 120px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #f7f7f7;
    flex-shrink: 0;
    margin-left: 20px;
  }
}

.action-warning-wrap {
  margin-top: 30px;
  height: 40px;

  .has-no-more {
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
    color: rgb(170, 169, 169);
    line-height: 40px;
    user-select: none;
  }
}

.subscribe-card-wrap {
  width: 300px;
  background: #F5F7FA;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2;
}

.subscribe-card {
  width: 300px;
  height: 140px;
  box-sizing: border-box;
  padding: 30px;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .infos {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    h4 {
      width: 100%;
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      line-height: 20px;
      font-weight: 500;
    }

    h5 {
      width: 100%;
      font-size: 24px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
      line-height: 24px;
      margin-top: 4px;
    }
  }

  .cover {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
    border-radius: 50%;
    cursor: auto;
    margin-left: 20px;
    border: 1px solid #f7f7f7;
  }
}

.subscribe-btn-wrap {
  width: 100%;
  height: 108px;
  background: #F5F7FA;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dialog-content-wrap {

  .close {
    width: 100%;
    height: 36px;
    background: #F5F7FA;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .texts-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 40px 40px 94px;
  }

  h5 {
    width: 100%;
    height: 24px;
    font-size: 24px;
    font-family: AlibabaPuHuiTiB;
    color: #000000;
    line-height: 24px;
    margin-bottom: 20px;
  }

  .summary {
    width: 100%;
    font-size: 15px;
    font-family: AlibabaPuHuiTiR;
    color: #303133;
    line-height: 24px;
  }
}
</style>

<style>
.menu-mask ul {
  width: 100%;
  border: none !important;
}

.menu-mask .el-menu {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.menu-mask .el-menu--inline {
  margin-bottom: 15px;
}

.menu-mask .el-submenu {
  width: 100%;
}

.menu-mask .el-submenu__title {
  padding: 0 !important;
}

.menu-mask .el-submenu__title:hover {
  background: #F5F7FA !important;
}

.menu-mask .el-menu-item:hover {
  background: #F5F7FA !important;
}

.menu-mask i {
  display: none;
}

.custom-title span {
  display: block;
  box-sizing: border-box;
  padding: 0 10px;
}

.menu-mask .el-menu-item {
  width: 100%;
  height: auto;
  padding: 0 !important;
}

.menu-mask .custom-title {
  width: 100%;
  height: 54px;
  box-sizing: border-box;
  padding: 0 40px;
  font-size: 15px;
  font-family: AlibabaPuHuiTiM;
  color: #606266;
  line-height: 54px;
}

.menu-mask .custom-sub-item {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 13px;
  font-family: AlibabaPuHuiTiM;
  color: #909399;
  line-height: 40px;
}

.menu-mask .custom-sub-item i {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1px solid #909399;
  margin-right: 4px;
}

.menu-mask .el-menu-item.is-active {
  background: none;
}

.menu-mask .el-menu-item.is-active p {
  color: #303133;
}
</style>
